import { useCallback } from "react";
import { useMISReportDownload } from "@hooks/useMISReportDownload";
import { MIS_FIELDS_REVENUE } from "@constants/misDownloadData";
import { ATP_API_URL } from "@config/apiconfig";

export const useRevenueDownload = () => {
  const dataMapper = useCallback(
    (item) => ({
      "Sr No": item.sr_no,
      Month: item.month || "-",
      "Total Policies Sold": item.total_policies_sold || "-",
      "Total Premium Collected (₹)": item.total_premium_collected || "-",
      "Total Claims Paid (₹)": item.total_claims_paid || "-",
      "Loss Ratio (%)": item.loss_ratio || "-",
      "Net Revenue (₹)": item.net_revenue || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "revenue",
    reportName: "Revenue",
    fields: MIS_FIELDS_REVENUE,
    dataMapper,
    apiUrl: ATP_API_URL.MIS_REVENUE, // Revenue doesn't seem to have a specific API URL in the original
    sheetName: "Revenue",
  });
};

export default useRevenueDownload;
